import React from 'react'
import { Link } from 'react-router-dom'
import { titleFormatter } from '../../../../helpers/titleFormatter'

function PostTemplate({title, author, image, id, date, url, type}) {
    return (
        <div className="col-md-6 col-lg-4 my-3">
            <div className="card">
                {type === "external" ? 
                    <a href={url} ><img src={image} alt={title} className="img-fluid" style={{objectFit: "cover", width: "500px", height: "300px"}} /></a>
                : (
                    <Link to={`/innlegg/single/${id}`}>
                        <img src={image} alt={title} className="img-fluid" style={{objectFit: "cover", width: "500px", height: "300px"}} />
                    </Link>
                )}

                <div className="card-body">
                    {type === "external" ? 
                        <a href={url} >
                            <h6 className="font-weight-bold">{titleFormatter(title)}</h6>
                        </a>
                    : (
                        <Link to={`/innlegg/single/${id}`}>
                            <h6 className="font-weight-bold">{titleFormatter(title)}</h6>
                        </Link>
                    )}

                    <small className="text-muted">Av {author} den {date}</small>
                </div>
            </div>
        </div>
    )
}
export default PostTemplate